import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQotdIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 26.698,
	height: 22.531,
	fill: "#142735",
	viewBox: "0 0 26.698 22.531",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_7828",
		"data-name": "Group 7828",
		transform: "translate(-45.08 -74.907)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Path_9566",
			"data-name": "Path 9566",
			d: "M54.208,86.733c-4.389-3.393,1.819-8.644,1.819-9.707,0-.493-2.233-2.119-2.639-2.119-1.687,0-12.813,11.254-6.261,19.823C52.62,101.915,62.636,93.248,54.208,86.733Z"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_9567",
			"data-name": "Path 9567",
			d: "M68.532,86.733c-4.39-3.393,1.818-8.644,1.818-9.707,0-.493-2.232-2.119-2.639-2.119-1.687,0-12.812,11.254-6.261,19.823C66.944,101.915,76.96,93.248,68.532,86.733Z"
		})]
	})
});
export { SvgQotdIcon as ReactComponent };
